import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';

const AppDrawerContainer = styled.nav`
  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: ${props => props.theme.drawerWidth}px;
    flex-shrink: 0;
    margin-right: -${props => props.theme.spacing(2)}px;
    transition: ${props =>
      props.theme.transitions.create('width', {
        easing: props.theme.transitions.easing.easeOut,
        duration: props.theme.transitions.duration.enteringScreen,
      })};

    &.closed {
      width: ${props => props.theme.spacing(2)}px;
      transition: ${props =>
        props.theme.transitions.create('width', {
          easing: props.theme.transitions.easing.sharp,
          duration: props.theme.transitions.duration.leavingScreen,
        })};
    }
  }
`;

const AppDrawerBase = styled(props => <Drawer classes={{ paper: 'paper' }} {...props} />)`
  && {
    .paper {
      flex-direction: row;
      width: ${props => props.theme.drawerWidth}px;
      height: 100%;
      overflow: visible;

      @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
        background-color: transparent;
        box-shadow: none;
        border: 0;
      }
    }
  }
`;

const AppDrawer = props => {
  const { open, children, anchor, onClose, ModalProps } = props;
  return (
    <AppDrawerContainer className={clsx({ closed: open })}>
      <Hidden mdUp implementation="js">
        <AppDrawerBase
          variant="temporary"
          open={open}
          anchor={anchor}
          onClose={onClose}
          ModalProps={ModalProps}
        >
          {children}
        </AppDrawerBase>
      </Hidden>
      <Hidden smDown implementation="js">
        <AppDrawerBase variant="persistent" open={!open}>
          {children}
        </AppDrawerBase>
      </Hidden>
    </AppDrawerContainer>
  );
};

AppDrawer.defaultProps = {
  anchor: 'left',
  open: false,
  onClose: undefined,
  ModalProps: undefined,
};

AppDrawer.propTypes = {
  anchor: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  ModalProps: PropTypes.object,
};

export default AppDrawer;
